<template>
  <div class="noData">
    <section class="main_content" style="    height: 100vh;">
      <ul class="no_record" style="margin:0">
        <div class="page-status-panel">
          <div class="img-block">
            <img src="../assets/images/icons/norecord.svg" alt />
          </div>
          <div class="details-block"><p>आपके पिनकोड पर अभी कोई शॉप नहीं मिली?</p>
         </div>
          <div class="btn-block" @click="goToNoData()">
            <span class="success">अपने दुकानदार को व्हाट्सएप करें</span>
        </div>
        </div>
      </ul>
    </section>
  </div>
</template>
<script>
import NoDataFound from "../components/Common/NoDataFound";
import constant from "../utils/constant";
import ApiCaller from "../utils/apicaller";
import { mapGetters } from "vuex";
export default {
  name: "NoShopData",
  components: {
      NoDataFound
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  methods: {
      goToNoData(){
        // try {
        //     JSBridgePlugin.genericIntentLaunch('https://bit.ly/local91');
        // } catch (err) {
        //     console.log(err);
        // }
        const obj = {
          message: `Increase your sales, get new customers at your shop through Mall91 - local shopping app with 1.7 Crore+ users! Create your shop, add products in 1 minute and start getting orders from me and 1000s of other users. Download from here and use my referral code ${this.userInfo.referralCode} https://m91.co/mrV40`
        };
        try {
          JSBridgePlugin.share(JSON.stringify(obj));
        } catch (err) {
          console.log(err);
          window.open("whatsapp://send?text=" + obj.message);
        }
        try {
          JSBridgePlugin.fireEvents("WHATSAPP_CLICK_ON_NO_SHOP_AVAILABLE");
        } catch (err) {
          console.log(err);
        }
      }
  },
  mounted(){
    try {
        JSBridgePlugin.fireEvents("NO_SHOP_ON_PINCODE");
      } catch (err) {
        console.log(err);
      }
      ApiCaller(
        constant.LOCAL_SHOP_URL,
        'add-user-traking/?orderSourceType=' + 'NO_SHOPS_AVAILABLE',
        'post'
      )
        .then((data) => {
          
        })
        .catch((err) => {
          console.log(err);
        });
  }
}
</script>
<style lang="scss" scoped>
.page-status-panel {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
  padding: 15px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .img-block {
    width: 100%;
    height: 200px;
    margin-top: 25px;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  .bg_stars {
    background-image: url("../assets/images/icons/star_ptrn.svg");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
  }
  .details-block {
    width: 100%;
    padding: 15px;
    align-self: flex-end;
    h2 {
      color: #262626;
      font-size: 1.25em;
      text-align: center;
      padding: 15px 0px 20px;
    }
    p {
      color: #999;
      font-size: 1em;
      line-height: 28px;
      text-align: center;
    }
  }
  .btn-block {
  width: 100%;
  text-align: center;
  span {
    &.money-transfer {
      background: #ff9933;
      padding: 10px 35px;
      font-size: 1em;
      color: #fff;
      border-radius: 9px;
      display: block;
      width: max-content;
      margin: 0 auto 15px;
    }
    &.gotohome {
      color: #ff9933;
    }
  }
  .success {
    background: #138808;
    color: #fff;
    border-radius: 10px;
    padding: 4px 16px;
  }
}
}
</style>